module.exports = __webpack_public_path__ + "f8844ddd54cddb124c438dfbf2255ec4.svg";